import { http } from "@/api/index";

const Qs = require("qs");

/**
 * @summary Busca todos os usuários da empresa se você for company administrator.
 * Busca todos os usuários do sistema se você for global administrator.
 * @returns {Promise} Array de todos os usuários.
*/
const GetAllUsers = function()
{
	return http.get("/Users");
};

/**
* @summary Requisição para buscar o usuário que está utilizando a aplicação.
* @returns {Promise} Promise do próprio usuário.
*/
const GetMe = function()
{
	return http.get("/Users/me");
};

/**
 * @summary Cria um novo usuário na base de dados.
 * @param {object} userModel Informações do novo usuário.
 * @returns {Promise} Promise de criação do usuário.
 */
const CreateUser = function(userModel)
{
	return http.post("Users", userModel);
};

/**
 * @summary Cria um novo usuário na base de dados.
 * @param {string} userId
 * @param {object} userModel Informações do novo usuário.
 * @returns {Promise} Promise de criação do usuário.
 */
const UpdateUser = function(userId, userModel)
{
	return http.put(`/Users/${userId}`, userModel);
};

/**
 * @summary Cria uma ou mais novas claim para um usuário.
 * @param {string} userId Id usuário.
 * @param {array} claimsModel Array de claims que contem um objeto com o tipo e valor.
 * @returns {Promise} Promise
 */
const CreateUserClaims = function(userId, claimsModel)
{
	const config = {
		headers:
		{
			"Accept":       "application/json",
			"Content-Type": "application/json",
		},
	};
	return http.post(`/Users/${userId}/Claims`, claimsModel, config);
};

/**
 * @summary Cria uma nova role para um usuário.
 * @param {string} userId Id usuário.
 * @param {string} role Role do usuário.
 * @returns {Promise} Promise.
 */
const CreateUserRole = function(userId, role)
{
	const config = {
		headers:
		{
			"Accept":       "application/json",
			"Content-Type": "application/json",
		},
	};
	return http.post(`/Users/${userId}/Roles`, role, config);
};

/**
 * @summary Atualiza usuário na página de perfil.
 * @param {string} userId Id do usuário.
 * @param profileForm Informações perfil gerais do usuário.
 * @returns {Promise} Promise
 */
const UpdateUserProfile = function(userId, profileForm)
{
	const params = {
		login:    "",
		name:     "",
		password: "",
	};

	params.login = profileForm.login;
	params.name = profileForm.name;
	params.password = profileForm.password;

	return http.patch(`/Users/${userId}`, params);
};

/**
 * @summary Requisição para atualizar a role do usuário para a base de dados.
 * @param {string} userId Id do usuário em questão.
 * @param {string} newRole Nova role de usuário.
 * @returns {Promise} Promise
 */
const UpdateUserRoles = function(userId, newRole)
{
	return http.put(`/Users/${userId}/Roles`, newRole,
		{
			headers:
			{
				"Accept":       "application/json",
				"Content-Type": "application/json",
			},
		});
};

/**
 * @summary Atualiza uma ou mais claims para um usuário.
 * @param {string} userId Id usuário.
 * @param {array} claimsModel Array de claims que contém um objeto com o tipo e valor.
 * @returns {Promise} Promise
 */
const UpdateUserClaims = function(userId, claimsModel)
{
	return http.put(`/Users/${userId}/Claims`, claimsModel);
};

/**
 * @summary Requisição para atualizar a imagem para a base de dados.
 * @param {string} userId Id do usuário em questão.
 * @param {File} profilePicture Nova imagem de perfil.
 * @returns {Promise} Promise
 */
const UpdateUserImage = function(userId = "", profilePicture = File)
{
	const img = new FormData();
	img.append("file", profilePicture);
	const config = {
		headers:
		{ "Content-Type": "multipart/ -data, boundary=----WebKitFormBoundaryNhECEUcQhR0mSaia", },
	};
	return http.patch(`/Users/${userId}/picture`, img, config);
};

/**
 * @summary Requisição para deletar um usuário na base de dados.
 * @param {string} userId Id do usuário.
 * @returns {promise} Promise de deletar o usuário.
 */
const DeleteUser = function(userId)
{
	return http.delete(`/Users/${userId}`);
};

/**
 * @summary Requisição para deletar uma role de usuário na base de dados
 * @param {string} userId Id do usuário.
 * @param {string} roleId Id da role.
 * @returns {promise} Promise
 */
const DeleteUserRoles = function(userId, roleId)
{
	return http.delete(`/Users/${userId}/Roles/${roleId}`);
};

/**
 * @summary Requisição para deletar uma imagem de perfil na base de dados.
 * @param {string} userId Id do usuário.
 */
const DeleteUserImage = function(userId)
{
	return http.delete(`Users/${userId}/picture`);
};

export default
{
	GetMe,
	GetAllUsers,
	CreateUser,
	CreateUserClaims,
	CreateUserRole,
	UpdateUser,
	UpdateUserClaims,
	UpdateUserRoles,
	UpdateUserProfile,
	UpdateUserImage,
	DeleteUser,
	DeleteUserRoles,
	DeleteUserImage,
};
